import { IStore } from '@app/redux'
import { auth, errorHandler } from '@app/services'
import axios from 'axios'
import { createContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

export const BankAccountsContext = createContext({
  accounts: null as any[],
  setAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  bankAccounts: null as any[],
  setBankAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  ogbAccounts: null as any[],
  setOGBAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  zelleAccounts: null as any[],
  setZelleAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  cardAccounts: null as any[],
  setCardAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  wireAccounts: null as any[],
  setWireAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  hifiAccounts: null as any[],
  setHifiAccounts: null as React.Dispatch<React.SetStateAction<any[]>>,
  fetchAccounts: null as () => Promise<void>,
})

export const BankAccountsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user } = useSelector((state: IStore) => state)

  //const [wallets, setWallets] = useState([])
  const [accounts, setAccounts] = useState([])
  const [bankAccounts, setBankAccounts] = useState([])
  const [ogbAccounts, setOGBAccounts] = useState([])
  const [zelleAccounts, setZelleAccounts] = useState([])
  const [cardAccounts, setCardAccounts] = useState([])
  const [wireAccounts, setWireAccounts] = useState([])
  const [hifiAccounts, setHifiAccounts] = useState([])

  const fetchAccounts = async () => {
    if (user?.registrationStepNo != 4) return
    try {
      //const identity = user?.selectedEntityIdentityId ? user?.selectedEntityIdentityId : user?.fortressIdentityId
      //const custodial = user?.selectedEntityCustodialId ? user?.selectedEntityCustodialId : user?.fortressCustodialId

      const params = { identityId: null, custodialId: null }
      const authorization = await auth.currentUser.getIdToken()
      const headers = {
        Authorization: authorization,
      }
      const res = await axios.get('/api/north-one/bank-accounts', { params, headers })

      //check if item['type'] ends with the word Local
      //item['type'].endsWith('Local')
      setAccounts(
        res.data.bankAccounts.filter((item) => {
          return (
            (item['type'] === 'ach' ||
              item['type'] === 'wire' ||
              item['type'] === 'ogb' ||
              item['type'].endsWith('Local')) &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId'])
          )
        }),
      )
      setBankAccounts(
        res.data.bankAccounts.filter(
          (item) =>
            item['type'] === 'ach' &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId']),
        ),
      )
      setOGBAccounts(
        res.data.bankAccounts.filter(
          (item) =>
            (item['type'] === 'ogb' || item['type'].endsWith('Local')) &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId']),
        ),
      )
      setZelleAccounts(
        res.data.bankAccounts.filter(
          (item) =>
            item['type'] === 'zelle' &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId']),
        ),
      )
      setWireAccounts(
        res.data.bankAccounts.filter(
          (item) =>
            item['type'] === 'wire' &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId']),
        ),
      )

      setHifiAccounts(
        res.data.bankAccounts.filter(
          (item) =>
            item['type'] === 'hifi' &&
            !item['hidden'] &&
            (user?.selectedEntityName
              ? item['custodialId'] === user?.selectedEntityIdentityId
              : item['custodialId'] === user?.uid || !item['custodialId']),
        ),
      )
    } catch (error) {
      //   Notification({ message: error.message, type: 'error' })
      errorHandler.report`Failed to fetch bank accounts: ${error}`
    }
  }

  useEffect(() => {
    fetchAccounts()
  }, [user?.fortressIdentityId, user?.fortressCustodialId, user?.selectedEntityName])

  const value = useMemo(
    () => ({
      accounts,
      setAccounts,
      bankAccounts,
      setBankAccounts,
      ogbAccounts,
      setOGBAccounts,
      zelleAccounts,
      setZelleAccounts,
      cardAccounts,
      setCardAccounts,
      wireAccounts,
      setWireAccounts,
      hifiAccounts,
      setHifiAccounts,
      fetchAccounts,
    }),
    [
      accounts,
      setAccounts,
      bankAccounts,
      setBankAccounts,
      ogbAccounts,
      setOGBAccounts,
      zelleAccounts,
      setZelleAccounts,
      cardAccounts,
      setCardAccounts,
      wireAccounts,
      setWireAccounts,
      hifiAccounts,
      setHifiAccounts,
      fetchAccounts,
    ],
  )

  return <BankAccountsContext.Provider value={value}> {children} </BankAccountsContext.Provider>
}
